var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dash-content-outer col" }, [
    _c("div", { staticClass: "head" }, [
      _c("h5", { staticClass: "txt-grt" }, [_vm._v("Contents")]),
      _vm._v(" "),
      _c("div", { staticClass: "actns" }, [
        _c("div", { ref: "innerSorter", staticClass: "sorter" }, [
          _c(
            "div",
            {
              staticClass: "dft",
              on: {
                click: function ($event) {
                  $event.preventDefault()
                  return _vm.toggleSorter.apply(null, arguments)
                },
              },
            },
            [
              _c("div", [
                _c("span", { staticClass: "placeholder" }, [
                  _vm._v("Sort by : "),
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "crt txt-main" }, [
                  _vm._v(_vm._s(_vm.currentSorting)),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "span",
                { staticClass: "arw", class: { spn: _vm.openedSorter } },
                [
                  _c(
                    "svg",
                    {
                      attrs: {
                        width: "13",
                        height: "8",
                        viewBox: "0 0 13 8",
                        fill: "none",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M12 1L6.5 6L1 0.999999",
                          stroke: "#FAC143",
                          "stroke-width": "2.5",
                        },
                      }),
                    ]
                  ),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _c(
            "ul",
            { staticClass: "extended col", class: { opnd: _vm.openedSorter } },
            [
              _c(
                "li",
                {
                  class: { active: _vm.currentSorting == "Last added" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.sortBy("Last added")
                    },
                  },
                },
                [_vm._v("Last added")]
              ),
              _vm._v(" "),
              _c(
                "li",
                {
                  class: { active: _vm.currentSorting == "Name" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.sortBy("Name")
                    },
                  },
                },
                [_vm._v("Name")]
              ),
            ]
          ),
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            ref: "addContentCta",
            staticClass: "btn main txt-blk",
            on: {
              click: function ($event) {
                $event.preventDefault()
                return _vm.openContentOverlay.apply(null, arguments)
              },
            },
          },
          [
            _c("span", { staticClass: "hvr" }),
            _vm._v(" "),
            _c("span", { staticClass: "ico" }, [
              _c(
                "svg",
                {
                  attrs: {
                    width: "26",
                    height: "26",
                    viewBox: "0 0 26 26",
                    fill: "none",
                  },
                },
                [
                  _c("path", {
                    attrs: {
                      "fill-rule": "evenodd",
                      "clip-rule": "evenodd",
                      d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z",
                      fill: "black",
                    },
                  }),
                ]
              ),
            ]),
            _vm._v(" "),
            _c("span", { staticClass: "txt" }, [_vm._v("Add new content")]),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "inner-content" },
      [
        _c(
          "transition-group",
          { staticClass: "all-contents", attrs: { name: "list", tag: "div" } },
          [
            _vm._l(_vm.sortedAssets, function (asset) {
              return _c("ContentCard", {
                key: asset.name,
                attrs: {
                  posterSrc: asset.poster,
                  title: asset.name,
                  genreTags: asset.tags,
                  moneyTag: _vm.Global.plans[asset.planIndex].name,
                  index: asset.index,
                },
              })
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                key: "more",
                staticClass: "card ft-bld more",
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.openContentOverlay.apply(null, arguments)
                  },
                },
              },
              [
                _c("div", { staticClass: "bg top" }),
                _vm._v(" "),
                _c("div", { staticClass: "bg bot" }),
                _vm._v(" "),
                _c("div", { staticClass: "ctnt col" }, [
                  _c("span", { staticClass: "ico" }, [
                    _c(
                      "svg",
                      {
                        attrs: {
                          width: "26",
                          height: "26",
                          viewBox: "0 0 26 26",
                          fill: "none",
                        },
                      },
                      [
                        _c("path", {
                          attrs: {
                            "fill-rule": "evenodd",
                            "clip-rule": "evenodd",
                            d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26ZM11.5 11.5V6.5H14.5V11.5H19.5V14.5H14.5V19.5H11.5V14.5H6.5V11.5H11.5Z",
                            fill: "#FFBB36",
                          },
                        }),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "txt txt-main" }, [
                    _vm._v("Add new content"),
                  ]),
                ]),
              ]
            ),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }